"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scopedCache = void 0;
const cache_1 = __importDefault(require("@emotion/cache"));
const stylis_1 = require("stylis");
const constants_1 = require("../shared/constants");
const bodyId = document.body.getAttribute('id');
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const customScopingPlugin = (element) => {
    // Adding * as default to skip undefined elements.
    const bodySelector = `${bodyId ? `#${bodyId}` : ''}.${constants_1.BODY_CLASS_NAME}`;
    const firstProp = element.props[0] || '*';
    if (element.type !== stylis_1.RULESET ||
        // Ignore the elements outside the app scope as adding the scope to them removes those styles.
        firstProp === 'html' ||
        firstProp === 'body' ||
        firstProp === '*') {
        return;
    }
    // TODO: Look into returning a new element instead of mutating it.
    // https://github.com/thysultan/stylis#prefixing
    element.props = [`${bodySelector} ${firstProp}`].concat(element.props.slice(1));
};
exports.scopedCache = (0, cache_1.default)({
    key: 'fee',
    prepend: true,
    stylisPlugins: [
        customScopingPlugin,
        // has to be included manually when customizing `stylisPlugins` if you want
        // to have vendor prefixes added automatically
        stylis_1.prefixer,
    ],
});
